import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MsalModule, MsalInterceptor, MsalGuard } from '@azure/msal-angular';


import { GrowlModule } from 'primeng/growl';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard, RedirectGuard } from './shared';
import { AuthGuardService } from './shared/services/routerguard.service';
import { DatacontextService } from './shared/services/datacontext.service';
import { DropDownsService } from './shared/services/dropdowns.service';
import { UtilsService } from './shared/services/utils.service';
import { EventsService } from './shared/services/events.service';
import { SignalrService } from './shared/services/signalr.service';
import { NotificationsService } from './shared/services/notification.service';
import { Interceptor } from './shared/interceptor/interceptor';
import { AuthenticationService } from './shared/services/authentication.service';
import { AnalyticsService } from './shared/services/analytics.service';
import { PrivilegesGuard, DeviceGuard } from './shared/guard';
import { NotificationsComponent } from './shared/components/notifications/notifications.component';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        GrowlModule,
        ToastModule,
        DialogModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        MsalModule.forRoot({
            auth: {
              clientId: '6a7bedb4-dab6-4d3a-b6ce-e3ea7cd1d973',
              authority: 'https://login.microsoftonline.com/7f90057d-3ea0-46fe-b07c-e0568627081b',              
              redirectUri: 'http://localhost:4200/'
            },
            cache: {
              cacheLocation: 'localStorage',
              storeAuthStateInCookie: true
           }
        })
    ],
    declarations: [
        AppComponent,
        NotificationsComponent
    ],
    providers: [
        AuthGuard,
        AuthGuardService,
        RedirectGuard,
        PrivilegesGuard,
        DeviceGuard,
        DatacontextService,
        AuthenticationService,
        DropDownsService,
        AnalyticsService,
        UtilsService,
        EventsService,
        SignalrService,
        MessageService,
        NotificationsService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: Interceptor,
            multi: true
        },
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        //{
        //    provide: HTTP_INTERCEPTORS,
        //    useClass: MsalInterceptor,
        //    multi: true
        //  },
        //  MsalGuard

    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule { }
